<template>
  <div class="swiper">
    <ul class="list" :style="{ height: height + 'px' }">
      <slot></slot>
    </ul>
    <div v-show="showTag" class="switch-btn left" @click="handleSwitch('left')">
      <i class="el-icon-caret-left icon"></i>
    </div>
    <div v-show="showTag" class="switch-btn right" @click="handleSwitch('right')">
      <i class="el-icon-caret-right icon"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "BaseSwiper",
  props: {
    height: {
      type: Number,
      default: 120,
    },
    num: {
      type: Number,
      default: 3,
    },
    // 如果我们希望两个轮播之间存在间隔 设置此参数而不用使用margin
    gap: {
      type: Number,
      default: 0,
    },
    delay: {
      type: Number,
      default: 200,
    },
    // 是否开启限速 用于处理点击速度过快的问题 目前使用delay 0进行处理，如果希望进行限速 也可以使用限速模式进行处理 即最快delay时间切换一张
    speedLimit: {
      type: Boolean,
      default: false, //默认不开启
    },
  },
  components: {},
  data() {
    return {
      offsetWidth: 0, // 偏移距离
      offsetArr: [],
      criticalIndex: -1, // 临界元素 次元素在移动的时候优先级最低
      showTag: true,
      canSwitch: true, // 是否可以进行切换
    }
  },
  computed: {
    // 获取子元素
    items() {
      return this.$children.length > 0
        ? this.$children.filter((v) => v.$options.name === "BaseSwiperItem")
        : []
    },
    // 子元素个数
    itemNumber() {
      return this.items.length
    },
  },
  mounted() {
    this.offsetWidth = (this.$el.offsetWidth + this.gap) / this.num
    // 获取最开始的时候的排列
    for (let i = 0; i < this.itemNumber; i++) {
      if (i === this.itemNumber - 1 && this.itemNumber > this.num) {
        this.offsetArr.push(-this.offsetWidth)
      } else {
        this.offsetArr.push(i * this.offsetWidth)
      }
    }
    if (this.itemNumber <= this.num) {
      this.showTag = false
    }
    this.updateItem()
  },
  methods: {
    updateItem() {
      // 逐个设置item的offsetWidth
      this.offsetArr.forEach((v, index) => {
        // 是否是临界元素
        let isCritical = this.criticalIndex === index
        this.items[index].setOffset(v, isCritical)
      })
    },
    handleSwitch(type) {
      // 如果不可以切换
      if (!this.canSwitch) return
      if (this.speedLimit) {
        this.canSwitch = false
        setTimeout(() => {
          this.canSwitch = true
        }, this.delay)
      }
      // 切换
      // 先全部向一边走
      // let oldOffsetArr = this.offsetArr
      if (this.itemNumber > 4) {
        this.switchExceed5(type)
      } else {
        this.switchUnder5(type)
      }
      // 切换后进行更新
      this.updateItem()
    },
    // 大于等于5张的时候的操作方式
    switchExceed5(type) {
      if (type === "left") {
        this.switchExceed5LeftMove()
      } else {
        this.switchExceed5RightMove()
      }
    },
    // 大于等于五张的时候向左移动
    switchExceed5LeftMove() {
      this.offsetArr = this.offsetArr.map((v, index) => {
        // 根据偏移量进行判断 如果已经是负数了 则往回走
        if (v >= (this.itemNumber - 2) * this.offsetWidth) {
          this.criticalIndex = index
          return -this.offsetWidth
        }
        return v + this.offsetWidth
      })
    },
    // 大于等于五张的时候向右移动
    switchExceed5RightMove() {
      this.offsetArr = this.offsetArr.map((v, index) => {
        // 根据偏移量进行判断 如果已经是负数了 则往回走
        if (v < 0) {
          this.criticalIndex = index
          return this.offsetWidth * (this.itemNumber - 2)
        }
        return v - this.offsetWidth
      })
    },
    // 小于五张的时候的操作
    switchUnder5(type) {
      if (type === "left") {
        this.switchUnder5LeftMove()
      } else {
        this.switchUnder5RightMove()
      }
    },
    switchUnder5LeftMove() {
      this.criticalIndex = this.offsetArr.findIndex(
        (v) => v === this.offsetWidth * (this.itemNumber - 2)
      )
      console.log(this.criticalIndex)
      let item = this.offsetArr.shift()
      this.offsetArr.push(item)
    },
    switchUnder5RightMove() {
      // 此时临界元素偏移量必定最大
      this.criticalIndex = this.offsetArr.findIndex(
        (v) => v === -this.offsetWidth
      )
      console.log(this.criticalIndex)
      let item = this.offsetArr.pop()
      this.offsetArr.unshift(item)
    },
    scrollToIndex(targetIndex) {
      if (this.itemNumber <= this.num) return
      const containerWidth = this.$el.offsetWidth
      const visibleMax = containerWidth - this.offsetWidth
      const currentOffset = this.offsetArr[targetIndex]
      if (currentOffset >= 0 && currentOffset <= visibleMax) return
      let rightSteps = 0
      let tempArr = [...this.offsetArr]
      while (rightSteps < this.itemNumber) {
        rightSteps++
        tempArr = tempArr.map((v) => {
          if (v < 0) return this.offsetWidth * (this.itemNumber - 2)
          return v - this.offsetWidth
        })
        if (tempArr[targetIndex] >= 0 && tempArr[targetIndex] <= visibleMax) break
      }
      let leftSteps = 0
      tempArr = [...this.offsetArr]
      while (leftSteps < this.itemNumber) {
        leftSteps++
        tempArr = tempArr.map((v) => {
          if (v >= (this.itemNumber - 2) * this.offsetWidth) return -this.offsetWidth
          return v + this.offsetWidth
        })
        if (tempArr[targetIndex] >= 0 && tempArr[targetIndex] <= visibleMax) break
      }
      const steps = Math.min(rightSteps, leftSteps)
      const direction = rightSteps <= leftSteps ? 'right' : 'left'
      for (let i = 0; i < steps; i++) {
        setTimeout(() => {
          this.handleSwitch(direction)
        }, i * 50)
      }
    },
  },
};
</script>
<style scoped lang="scss">
.swiper {
  position: relative;

  .list {
    padding: 0 0;
    overflow: hidden;
    position: relative;
  }

  .switch-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 85px;
    background-color: rgba($color: #000000, $alpha: 0.2);
    margin: 15px 0px;
    // transition: background-color 0.3s;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 99;
    box-sizing: border-box;

    .icon {
      color: rgba($color: #fff, $alpha: 0.7);
      font-size: 40px;
    }

    &:hover {
      background-color: #025393;

      .icon {
        color: rgba($color: #fff, $alpha: 1);
      }
    }
  }

  .switch-btn.left {
    // background: linear-gradient(to right, #025393, rgba(2, 83, 147, 0.7));
    left: 0px;
    // &:hover {
    //   background: linear-gradient(to right, #025393, rgba(2, 83, 147, 0.3));
    // }
  }

  .switch-btn.right {
    // background: linear-gradient(to left, #025393, rgba(2, 83, 147, 0.7));
    right: 0px;
    // &:hover {
    //   background: linear-gradient(to left, #025393, rgba(2, 83, 147, 0.3));
    // }
  }
}
</style>